/**
 * trwguaranteelabel Module Entry Point
 *
 * Import styles and JS, expose functions globally for OXID frontend usage.
 */

// Import styles first
import '../scss/trwguaranteelabel.scss';

// Import all exports from the main module
import * as TRWGuaranteeLabel from '../js/trwguaranteelabel.js';

// Expose all functions globally on window object
if (typeof window !== 'undefined') {
    // Expose each function individually
    Object.keys(TRWGuaranteeLabel).forEach(key => {
        window[key] = TRWGuaranteeLabel[key];
    });
}
